export default __webpack_public_path__ + "static/media/yarn-original.eba51f0e.svg";